import "bootstrap-icons/font/bootstrap-icons.css";
import { Badge, Button, Dropdown, Input, Menu, Popover, Table } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllLocations } from "../../redux/actions/location/getLocationAction";
import "../productCategory/productCategory.css";
import "./location.css";

const FILTER_STYLE = { marginBottom: 12 };
const FILTER_LABEL = { display: "block", marginBottom: 4, color: "rgba(0,0,0,0.65)", fontSize: 12 };

const columns = [
  {
    title: "S.No",
    key: "sNo",
    width: 60,
    render: (_, __, index) => index + 1,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
];

const menuItems = columns.map((item) => ({
  key: item.key,
  label: <span>{item.title}</span>,
}));

function CustomTable({
  list,
  columnItems,
  columnsToShow,
  setColumnsToShow,
  colVisibilityClickHandler,
  addKeys,
  filteredList,
  addLocationButton,
  filterContent,
  filterVisible,
  setFilterVisible,
  activeFilterCount,
}) {
  const total = (filteredList || list || []).length;
  const dataSource = filteredList ? addKeys(filteredList) : [];
  const hasCol = (key) =>
    Array.isArray(columnsToShow) && columnsToShow.some((c) => c.key === key);
  return (
    <div className="card card-custom list-page-fill-viewport location-list-page column-design">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 list-page-header mb-2" style={{ marginBottom: "8px" }}>
          <h5 className="mb-0">Location List</h5>
          <div className="location-header-actions">
            {list && (
              <>
                <Popover
                  content={filterContent}
                  title="Filters"
                  trigger="click"
                  open={filterVisible}
                  onOpenChange={setFilterVisible}
                  placement="bottomLeft"
                >
                  <Badge count={activeFilterCount} size="small" offset={[-2, 2]}>
                    <Button
                      type="primary"
                      className="filter-icon-btn"
                      icon={<FilterOutlined />}
                      onClick={() => setFilterVisible((v) => !v)}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Badge>
                </Popover>
                <Dropdown
                  overlay={<Menu onClick={colVisibilityClickHandler} items={columnItems} />}
                  placement="bottomRight"
                >
                  <Button className="column-visibility">Column Visibility</Button>
                </Dropdown>
              </>
            )}
            {addLocationButton}
          </div>
        </div>
        <div className="list-page-table-outer">
          <div className="list-page-table-container" style={{ minHeight: 420 }}>
            <div className="list-page-table-inner">
              <div className="list-page-table-wrap list-page-table-scroll-450">
                {/* Desktop table */}
                <div className="d-none d-lg-block">
                  <Table
                    scroll={{ x: true, y: 450 }}
                    loading={!list}
                    pagination={{
                      defaultPageSize: 10,
                      pageSizeOptions: [10, 20, 50, 100],
                      showSizeChanger: true,
                      hideOnSinglePage: false,
                      showTotal: (_, range) =>
                        total ? `${range[0]}-${range[1]} of ${total} items` : "0 items",
                    }}
                    columns={columnsToShow}
                    dataSource={dataSource}
                  />
                </div>

                {/* Mobile cards */}
                <div className="d-lg-none location-mobile-cards">
                  {dataSource && dataSource.length > 0 ? (
                    <div className="location-mobile-list">
                      {dataSource.map((record, idx) => (
                        <div key={record.key ?? idx} className="location-mobile-card">
                          <div className="location-mobile-card-body">
                            <div className="location-mobile-row">
                              {hasCol("sNo") && (
                                <span className="location-mobile-sno">{idx + 1}</span>
                              )}
                              {hasCol("name") && (
                                <div className="location-mobile-name">
                                  {record.name || "—"}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted mb-0">No locations found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const GetAllLocation = ({ addLocationButton }) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.locations?.list);
  const [columnItems, setColumnItems] = useState([]);
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterName, setFilterName] = useState("");

  useEffect(() => {
    dispatch(loadAllLocations());
  }, [dispatch]);

  useEffect(() => {
    setColumnItems(menuItems);
    setColumnsToShow(columns);
  }, []);

  const colVisibilityClickHandler = (col) => {
    const ifColFound = columnsToShow.find((item) => item.key === col.key);
    if (ifColFound) {
      setColumnsToShow(columnsToShow.filter((item) => item.key !== col.key));
    } else {
      const foundIndex = columns.findIndex((item) => item.key === col.key);
      const foundCol = columns.find((item) => item.key === col.key);
      const updated = [...columnsToShow];
      updated.splice(foundIndex, 0, foundCol);
      setColumnsToShow(updated);
    }
  };

  const addKeys = (arr) => (arr || []).map((i) => ({ ...i, key: i.id }));
  const nameLower = (filterName || "").trim().toLowerCase();
  const filteredList = list && nameLower
    ? list.filter((i) => (i.name || "").toLowerCase().includes(nameLower))
    : list;
  const activeFilterCount = nameLower ? 1 : 0;

  const filterContent = (
    <div style={{ width: 260 }}>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Name</label>
        <Input
          placeholder="Filter by name"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          allowClear
        />
      </div>
      <div style={{ textAlign: "center", marginTop: 8 }}>
        <Button size="small" onClick={() => setFilterName("")}>
          Clear All Filters
        </Button>
      </div>
    </div>
  );

  return (
    <CustomTable
      list={list}
      columnItems={columnItems}
      columnsToShow={columnsToShow}
      setColumnsToShow={setColumnsToShow}
      colVisibilityClickHandler={colVisibilityClickHandler}
      addKeys={addKeys}
      filteredList={filteredList}
      addLocationButton={addLocationButton}
      filterContent={filterContent}
      filterVisible={filterVisible}
      setFilterVisible={setFilterVisible}
      activeFilterCount={activeFilterCount}
    />
  );
};

export default GetAllLocation;
